import { render, staticRenderFns } from "./Password.vue?vue&type=template&id=0c930021&scoped=true&"
import script from "./Password.vue?vue&type=script&lang=ts&"
export * from "./Password.vue?vue&type=script&lang=ts&"
import style0 from "./Password.vue?vue&type=style&index=0&id=0c930021&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c930021",
  null
  
)

export default component.exports